import Lenis from 'lenis'

window._getLenis = () => {
  window._lenis = new Lenis({
    anchors: {
      offset: -50
    }
  })
  return window._lenis
}

window._getLenis()

const raf = (time) => {
  window._lenis.raf(time)
  requestAnimationFrame(raf)
}
requestAnimationFrame(raf)
